var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldCain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 149,
    viewBox: "0 0 117 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1008_5576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6328 81.4746V120.471",
    stroke: "black",
    strokeWidth: 8.29124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6816 81.4746V120.471",
    stroke: "black",
    strokeWidth: 8.29124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8196 47.2219C17.8196 47.2219 3.9431 54.1669 4.23875 61.7222C4.50294 68.5036 18.4863 70.7683 18.4863 70.7683",
    stroke: "black",
    strokeWidth: 8.29124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6465 75.2034L32.8613 79.6509C32.2763 86.1493 30.3829 91.119 25.3947 92.4527C18.2741 94.6607 12.3486 90.3201 12.3486 86.3443C12.3486 84.6773 14.2105 84.281 14.2105 84.281C14.2105 84.281 11.6378 82.6265 13.657 80.4876C14.4433 79.6509 16.5883 80.4373 16.5883 80.4373C16.5883 80.4373 17.0097 78.2167 18.2489 77.8015C18.9912 77.5561 20.8028 78.3865 20.8028 78.3865L26.6465 75.2034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7592 67.0186C21.7592 67.0186 22.2499 68.4088 21.8158 70.1891C21.3315 72.1833 20.2306 73.1458 20.2306 73.1458C18.8089 74.2152 18.5195 76.2409 19.5889 77.6626C20.6583 79.0843 22.684 79.3737 24.1057 78.3042C24.1057 78.3042 26.968 76.2912 28.0877 71.7178C29.0565 67.7357 27.7606 64.6344 27.7606 64.6344C27.1001 62.9799 25.2254 62.1747 23.571 62.8289C21.9165 63.4895 21.1113 65.3641 21.7655 67.0186H21.7592Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2541 85.0475H59.1735C79.8183 85.0475 96.582 68.2826 96.582 47.6363C96.582 26.99 79.8183 10.2251 59.1735 10.2251",
    fill: "#AA7C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.4551 75.983L76.7806 76.0711L81.3225 71.3215L88.2109 71.2146L83.4551 75.9893V75.983Z",
    fill: "#E7BB29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.3223 77.7812L74.415 77.863L70.5713 80.2535L78.5292 79.6496L81.3223 77.7812Z",
    fill: "#E7BB29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1035 31.8717L85.9257 31.4565C85.1897 29.714 82.4973 25.6879 80.522 23.4609L88.2093 24.0649C89.8323 26.21 92.0026 29.7077 93.1035 31.8717Z",
    fill: "#F3E9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2536 85.0475C31.5934 85.0475 14.845 68.298 14.845 47.6363C14.845 26.9747 31.5934 10.2251 52.2536 10.2251C72.9137 10.2251 89.6621 26.9747 89.6621 47.6363C89.6621 68.298 72.9137 85.0475 52.2536 85.0475Z",
    fill: "#ECD559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2536 85.0475C31.5934 85.0475 14.845 68.298 14.845 47.6363C14.845 26.9747 31.5934 10.2251 52.2536 10.2251C72.9137 10.2251 89.6621 26.9747 89.6621 47.6363C89.6621 68.298 72.9137 85.0475 52.2536 85.0475Z",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5088 47.6369C24.597 17.8752 52.4002 16.3906 51.9976 16.3906C34.7496 16.3906 20.7536 30.3939 20.7536 47.6369C20.7536 64.8799 34.7559 78.8831 51.9976 78.8831C52.4002 78.8831 24.0246 77.1909 23.5088 47.6369Z",
    fill: "#A67705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2539 79.1407C34.8559 79.1407 20.752 65.0358 20.752 47.6365C20.752 30.2372 34.8559 16.1323 52.2539 16.1323C69.652 16.1323 83.7559 30.2372 83.7559 47.6365C83.7559 65.0358 69.652 79.1407 52.2539 79.1407Z",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2541 85.0475H59.1735C79.8183 85.0475 96.582 68.2826 96.582 47.6363C96.582 26.99 79.8183 10.2251 59.1735 10.2251",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1738 10.2251H52.254",
    stroke: "#0B1420",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9414 5.24294C63.224 3.30539 59.5565 2.09127 56.323 2.98456",
    stroke: "black",
    strokeWidth: 3.68639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8669 6.97871C37.3075 4.82726 40.7737 3.12875 44.1016 3.58169",
    stroke: "black",
    strokeWidth: 3.68639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0419 45.856C94.0419 45.856 114.724 52.7632 112.416 61.7527C110.491 69.2639 93.8469 69.05 93.8469 69.05",
    stroke: "black",
    strokeWidth: 8.29124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2756 51.1775C60.2756 51.1775 55.6836 53.8951 50.8212 53.5428C45.9588 53.1905 41.6185 51.6053 41.6185 51.6053C41.6185 51.6053 40.7756 57.808 44.1912 63.4697C47.6068 69.1314 50.7143 70.1567 53.9349 69.6157C57.1556 69.0747 61.0556 65.4764 62.3828 59.777C60.2127 57.7828 59.1433 54.1656 60.263 51.1775H60.2756Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4258 51.0151C54.6827 54.0976 48.0653 54.3052 41.4479 51.9839C41.4919 53.651 41.5611 55.1482 41.8567 56.6894C44.5679 59.5391 54.6953 59.4825 59.998 55.6892C59.4885 54.1857 59.7905 52.8332 60.4258 51.0151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5944 66.0492C52.997 65.1873 53.5821 64.1053 55.3309 63.7845C57.6711 63.3567 59.3633 65.0049 59.3633 65.0049C59.3633 65.0049 58.1051 68.6473 53.6513 69.2889C49.0967 69.9495 47.6058 66.3511 47.6058 66.3511C47.6058 66.3511 47.9267 65.0993 49.4742 64.4136C50.6002 63.9166 51.9905 64.099 53.2927 64.8162",
    fill: "#FF7EB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5944 66.0492C52.997 65.1873 53.5821 64.1053 55.3309 63.7845C57.6711 63.3567 59.3633 65.0049 59.3633 65.0049C59.3633 65.0049 58.1051 68.6473 53.6513 69.2889C49.0967 69.9495 47.6058 66.3511 47.6058 66.3511C47.6058 66.3511 47.9267 65.0993 49.4742 64.4136C50.6002 63.9166 51.9905 64.099 53.2927 64.8162",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0195 47.6373C70.1446 45.4733 63.9734 45.8444 61.2306 49.6315C56.7768 55.7713 63.8979 62.7163 68.6474 63.7731",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4258 51.0143C53.3051 55.0279 45.7316 54.3736 37.7555 49.6304",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4141 59.784C61.4516 63.7724 58.3694 69.4655 52.8339 69.6165C44.4929 69.8492 40.8005 57.3054 41.6749 51.6375",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3796 46.8439C41.4569 46.8439 37.4662 41.8193 37.4662 35.6212C37.4662 29.423 41.4569 24.3984 46.3796 24.3984C51.3023 24.3984 55.293 29.423 55.293 35.6212C55.293 41.8193 51.3023 46.8439 46.3796 46.8439Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4102 44.2213C52.5483 43.3469 50.7492 41.6924 48.4971 41.359C45.8612 40.969 43.4644 41.8182 42.7095 43.8816C41.7282 46.5741 43.8671 49.7886 47.1823 50.6442C48.7361 51.0468 50.5919 50.9776 52.1646 50.2479",
    fill: "#ECD559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4102 44.2213C52.5483 43.3469 50.7492 41.6924 48.4971 41.359C45.8612 40.969 43.4644 41.8182 42.7096 43.8816C41.7282 46.5741 43.8671 49.7886 47.1823 50.6442C48.7361 51.0468 50.5919 50.9776 52.1646 50.2479",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1491 46.8437C54.2264 46.8437 50.2357 41.8191 50.2357 35.6209C50.2357 29.4228 54.2264 24.3982 59.1491 24.3982C64.0718 24.3982 68.0625 29.4228 68.0625 35.6209C68.0625 41.8191 64.0718 46.8437 59.1491 46.8437Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7966 31.3315C56.5319 31.3315 54.6887 33.6465 54.6887 36.5026C54.6887 39.3586 56.5256 41.6736 58.7966 41.6736C60.9354 41.6736 62.5521 39.4341 62.7031 38.113L59.0859 36.4459L62.6402 34.6782C62.3446 33.1244 60.797 31.3315 58.7966 31.3378V31.3315Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3219 30.5071C44.0573 30.5071 42.2141 32.8221 42.2141 35.6781C42.2141 38.5341 44.051 40.8491 46.3219 40.8491C48.4608 40.8491 50.0775 38.6096 50.2285 37.2885L46.6113 35.6215L50.1656 33.8538C49.8699 32.2999 48.3224 30.5071 46.3219 30.5134V30.5071Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3614 125.674L53.8897 142.615L57.2613 142.407L82.9698 142.615C82.9698 142.615 84.1335 134.097 79.3843 129.882C74.6351 125.674 69.3576 125.856 66.1432 125.856C62.9289 125.856 54.3614 125.674 54.3614 125.674Z",
    fill: "#88CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4423 125.674L49.9141 142.615L46.5424 142.407L20.8339 142.615C20.8339 142.615 19.6702 134.097 24.4194 129.882C29.1686 125.674 34.4462 125.856 37.6605 125.856C40.8749 125.856 49.4423 125.674 49.4423 125.674Z",
    fill: "#88CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2524 126.296C56.2524 126.296 54.1576 131.587 57.2589 136.739C60.2911 141.778 67.2109 142.231 67.2109 142.231L53.8871 142.401L54.3589 125.667L56.2524 126.29V126.296Z",
    fill: "#4A97CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5487 126.296C47.5487 126.296 49.6436 131.587 46.5422 136.739C43.5101 141.778 36.5902 142.231 36.5902 142.231L49.9141 142.401L49.4423 125.667L47.5487 126.29V126.296Z",
    fill: "#4A97CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7499 77.8327L94.4546 78.185C96.3039 79.7136 97.2726 80.7642 96.933 82.0223L97.6438 82.5697C97.6438 82.5697 99.9901 80.7831 101.418 81.5505C105.45 83.7334 102.362 86.9354 102.362 86.9354C102.362 86.9354 104.274 89.6845 101.292 90.9552C99.273 91.8171 92.4794 95.2078 84.931 87.5708C74.9042 77.4112 84.8933 64.4585 87.1955 64.3264C87.1955 64.3264 86.3212 74.9641 92.7499 77.839V77.8327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8111 125.522C66.8111 125.522 61.6215 127.768 55.2746 126.038C53.5573 125.566 52.5446 123.792 53.0164 122.075C53.4881 120.358 55.262 119.345 56.9793 119.817C61.0051 120.917 64.3075 119.584 64.3075 119.584C65.9493 118.892 67.8427 119.659 68.5346 121.301C69.2265 122.943 68.4591 124.837 66.8173 125.529L66.8111 125.522Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4927 125.522C49.4927 125.522 44.3032 127.768 37.9562 126.038C36.239 125.566 35.2262 123.792 35.698 122.075C36.1698 120.358 37.9437 119.345 39.6609 119.817C43.6867 120.917 46.9891 119.584 46.9891 119.584C48.6309 118.892 50.5243 119.659 51.2162 121.301C51.9082 122.943 51.1408 124.837 49.499 125.529L49.4927 125.522Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8636 65.9495C93.8636 65.9495 93.3729 67.3397 93.807 69.12C94.2914 71.1142 95.3922 72.0767 95.3922 72.0767C96.814 73.1461 97.1033 75.1718 96.0339 76.5935C94.9645 78.0152 92.9388 78.3046 91.5171 77.2351C91.5171 77.2351 88.6548 75.2221 87.5351 70.6487C86.5663 66.6666 87.8622 63.5653 87.8622 63.5653C88.5227 61.9108 90.3974 61.1056 92.0518 61.7598C93.7063 62.4204 94.5115 64.295 93.8573 65.9495H93.8636Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9028 144.251C52.9028 143.232 53.7268 142.408 54.7459 142.408H82.1276C83.1467 142.408 83.9707 143.232 83.9707 144.251V146.056C83.9707 147.075 83.1467 147.9 82.1276 147.9H54.7459C53.7268 147.9 52.9028 147.075 52.9028 146.056V144.251Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9082 144.251C50.9082 143.232 50.0842 142.408 49.0651 142.408H21.6834C20.6643 142.408 19.8403 143.232 19.8403 144.251V146.056C19.8403 147.075 20.6643 147.9 21.6834 147.9H49.0651C50.0842 147.9 50.9082 147.075 50.9082 146.056V144.251Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9028 144.251C52.9028 143.232 53.7268 142.408 54.7459 142.408H82.1276C83.1467 142.408 83.9707 143.232 83.9707 144.251V146.056C83.9707 147.075 83.1467 147.9 82.1276 147.9H54.7459C53.7268 147.9 52.9028 147.075 52.9028 146.056V144.251Z",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9082 144.251C50.9082 143.232 50.0842 142.408 49.0651 142.408H21.6834C20.6643 142.408 19.8403 143.232 19.8403 144.251V146.056C19.8403 147.075 20.6643 147.9 21.6834 147.9H49.0651C50.0842 147.9 50.9082 147.075 50.9082 146.056V144.251Z",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9688 142.615C82.9688 142.615 84.7489 132.864 77.1628 128.108C70.407 123.874 61.1791 125.674 57.2602 133.009",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8344 142.615C20.8344 142.615 19.0543 132.864 26.6404 128.108C33.3962 123.874 42.6241 125.674 46.543 133.009",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8895 142.615L54.3613 125.674",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9141 142.615L49.4423 125.674",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7249 77.8328C92.8884 79.569 92.0958 82.4879 90.7055 83.7335",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8133 83.1927C90.977 83.6582 92.7446 86.0173 92.7446 86.0173C93.7322 86.703 95.4935 86.7344 96.632 86.3192C96.632 86.3192 98.8588 85.0799 101.155 85.9858C103.287 86.8225 103.237 89.7162 101.52 90.8171C99.557 92.0753 94.5625 93.5851 89.1843 90.7857C81.0131 86.5268 78.9499 77.0278 82.3593 69.85C83.4601 67.535 85.5296 65.4653 87.6431 64.0059",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.358 86.9353C103.717 85.0732 103.83 82.8337 102.075 81.8398C100.181 80.764 98.6587 81.8901 96.6205 83.2426C94.7018 84.5133 92.5693 84.6958 91.5313 84.5448",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5703 82.43C97.5703 82.43 96.8343 82.1091 95.897 82.4425C94.6703 82.8829 92.8963 83.0024 91.6192 82.518",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9161 77.8328C95.0233 78.5688 97.678 80.0408 96.7344 82.2992",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6328 78.7439C19.9534 81.4112 20.8971 85.0472 22.7969 86.8464",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8613 79.6443C32.6475 82.5632 31.5592 89.5963 27.307 91.6974C24.1178 93.2701 19.8718 93.4966 17.1167 92.1063C14.2671 90.672 12.0844 87.7342 12.38 86.1489C12.6379 84.7461 13.7387 84.2428 15.0031 84.4064C16.8776 84.6455 18.0602 86.2119 19.2491 87.5203",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6719 85.6902C21.6719 85.6902 21.3133 85.8915 21.2378 85.9418C20.9421 86.118 20.6591 86.3256 20.3886 86.5331C19.5645 87.1559 18.8473 87.8731 18.2497 88.7098",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2158 84.2744C14.2724 84.3121 13.2847 83.6327 12.9954 82.7961C12.6179 81.6952 13.1023 80.4936 14.3227 80.1854C16.9711 79.506 20.7141 83.0414 21.6074 85.2809",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8702 80.4807C15.914 79.5056 17.4804 76.8761 19.959 78.1279",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1008_5576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 148.462,
    fill: "white",
    transform: "matrix(-1 0 0 1 117 0.32373)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldCain);
export default __webpack_public_path__ + "static/media/gold_cain.da81454f662c09c6a6d0267c8c4cc836.svg";
export { ForwardRef as ReactComponent };